import { useSetRecoilState } from 'recoil'
import { getChecklistBySubmittedID } from '../../services/um/umServiceURL'
import { CheckListInTopicType } from '../../services/web/types/requestWebServiceTypes'
import useCallApi from '../../utilities/axios'
import { checklistStore } from './useChecklistStore'

const useChecklistAction = () => {
    const setChecklistStore = useSetRecoilState(checklistStore)
    const callApi = useCallApi()

    const setChecklist = (param: CheckListInTopicType) => {
        setChecklistStore((prevState) => ({
            checklist: [...prevState.checklist.filter((item) => item.topicID !== param.topicID), param],
        }))
    }

    const getChecklist = async (submittedID: number, committeeID: number, irb: number) => {
        const { data } = await callApi.axiosPost({
            url: getChecklistBySubmittedID,
            params: { submittedID, committeeID, irb },
        })

        setChecklistStore(() => ({
            checklist: [...data.result],
        }))
    }

    const clearChecklist = () => {
        setChecklistStore({
            checklist: [],
        })
    }

    return {
        setChecklist,
        getChecklist,
        clearChecklist,
    }
}

export default useChecklistAction
